import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { ShoppingCartAddedItemModal } from '../..//ShoppingCart/ShoppingCartAddedItemModal/ShoppingCartAddedItemModal'
import { ShoppingCartNavbarProps } from './ShoppingCartNavbar.types'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { useCartItemsCount } from '../hooks/useCartItemsCount'
import { useIsMobileOrTablet } from '@app/code/src/hooks/useIsMobileOrTablet'
import { useRouter } from 'next/router'

export const ShoppingCartNavbar: FC<ShoppingCartNavbarProps> = ({
  handleBack,
  handleCart,
  ...props
}) => {
  const { itemsCount } = useCartItemsCount()
  const router = useRouter()
  const isMobileOrTablet = useIsMobileOrTablet()
  return (
    <Box
      width="100%"
      justifyContent="space-between"
      height="52px"
      alignItems="center"
      pl="20px"
      pr="16px"
      borderTop="1px solid"
      borderBottom="1px solid"
      borderColor="secondary.border"
      backgroundColor="primary.white"
      data-testid="shopping-cart-navbar"
      {...props}
    >
      <Box
        alignItems="center"
        cursor="pointer"
        onClick={() => {
          router.back()
          handleBack?.()
        }}
        data-testid="back-ctr"
        role="button"
        tabIndex={0}
      >
        <Icon alt="back" src="/icons/arrow-left.svg" display="flex" width="7px" height="12px" />
        <Spacer ml="16px" />
        <Text variant="body/medium">Back</Text>
      </Box>
      <Box>
        {isMobileOrTablet && (
          <Box
            onClick={() => handleCart?.()}
            data-testid="cart-ctr"
            cursor={handleCart ? 'pointer' : 'auto'}
            zIndex={8}
            aria-label="cart"
            tabIndex={handleCart ? 0 : -1}
          >
            <Box marginRight="2px">
              <Icon alt="cart" src="/icons/cart.svg" display="flex" width="20px" height="20px" />
              <Box
                minWidth="1em"
                height="1em"
                backgroundColor="primary.black"
                borderRadius=".5em"
                alignItems="center"
                marginTop="-.5em"
                marginLeft="-.5em"
                data-testid="cart-items-count-ctr"
              >
                <Text
                  variant="general/captionAndLabel"
                  fontWeight={700}
                  color="primary.white"
                  textAlign="center"
                  width="100%"
                  lineHeight="14px"
                  padding="2px 4px"
                  aria-label="cart-items-count"
                  data-testid={`cart-items-count-${itemsCount}`}
                >
                  {itemsCount}
                </Text>
              </Box>
            </Box>
            <Text variant="body/medium">Cart</Text>
          </Box>
        )}
        <Box>
          <ShoppingCartAddedItemModal />
        </Box>
      </Box>
    </Box>
  )
}
